import { ITag } from '@/interfaces';

export default class PresetTag {
  public name: string;
  public presettagid: string;
  public tags: ITag[];

  constructor() {
    this.name = '';
    this.presettagid = '';
    this.tags = [];
  }
}
